// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:991.98px){p[data-v-a9e4a7aa]{font-size:.875rem;line-height:1.3125rem}}.review-info[data-v-a9e4a7aa]{color:#9c9c9c;line-height:1.2rem}@media(min-width:992px){.review-info[data-v-a9e4a7aa]{min-height:2.8125rem}}.review-info p[data-v-a9e4a7aa]{margin-bottom:0}.separator[data-v-a9e4a7aa]{background:#e8e8e8;height:1px}", ""]);
// Exports
module.exports = exports;
